import { render, staticRenderFns } from "./bimPopover.vue?vue&type=template&id=36641384&scoped=true&"
import script from "./bimPopover.vue?vue&type=script&lang=js&"
export * from "./bimPopover.vue?vue&type=script&lang=js&"
import style0 from "./bimPopover.vue?vue&type=style&index=0&id=36641384&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36641384",
  null
  
)

export default component.exports